import { useState } from "react";
import { IconButton, SearchIcon, CancelIcon } from "@firecms/ui";
import {
  statsSearchDivider,
  statsSearchForm,
  statsSearchInput,
} from "./statsViewTheme";

type SearchBarProps = {
  onSearch: (searchTerm: string) => void;
  placeholder?: string;
  ariaLabel?: string;
};

export default function SearchBar({
  onSearch,
  placeholder = "Search teams or participants",
  ariaLabel,
}: SearchBarProps) {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const handleSearch = () => {
    onSearch(searchTerm);
  };

  const handleClean = () => {
    setSearchTerm("");
    onSearch("");
  };

  const resolvedAriaLabel = ariaLabel ?? placeholder;

  return (
    <form
      className={statsSearchForm}
      onSubmit={(e) => {
        e.preventDefault();
        handleSearch();
      }}
    >
      <input
        className={statsSearchInput}
        placeholder={placeholder}
        aria-label={resolvedAriaLabel}
        value={searchTerm}
        onChange={handleChange}
      />
      <IconButton
        type="submit"
        aria-label="search"
        disabled={!searchTerm}
      >
        <SearchIcon />
      </IconButton>
      <div className={statsSearchDivider} />
      <IconButton
        type="button"
        aria-label="cancel"
        onClick={handleClean}
      >
        <CancelIcon />
      </IconButton>
    </form>
  );
}
